import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../Constant";
import { ToastContainer, toast } from "react-toastify";
import messages from "../../assets/Messages.json";
import { useNavigate } from "react-router-dom";
import asiTitle from '../../asi.json';


import {
  showAppLoading,
  generateYearRange,
  isNumeric,
  validateButtonASIBlock,
  getStatusFlagValue,
} from "../../Custom/Custom";
function BlockG({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token,
}) {
  const [itemData, setItemData] = useState({});
  const [blockGData, setBlockGData] = useState([]);
  const navigate = useNavigate();
  const yearRange = generateYearRange(blockInfo.surveyYear);
  const [buttonStatus, setButtonStatus] = useState("");
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? String(decode_token.id.ROLE_CODE)
        .split("|")
        .map((r) => String(r).trim())
        .filter(Boolean)
    : [];
  const isDivasiRole = roleCodes.includes("DIVASI");
  const isHqRole = roleCodes.includes("HQADM") || roleCodes.includes("HQASI");
  const currentStatusFlag =
    Array.isArray(blockGData) && blockGData.length > 0 ? blockGData[0]?.statusFlag : "";
  const isDivasiStatusFlagOne =
    isDivasiRole && String(currentStatusFlag ?? "").trim() === "1";
  const isHqStatusFlagThree =
    isHqRole && String(currentStatusFlag ?? "").trim() === "3";
  const isRestrictedRoleWithEmptyStatusFlag =
    (isDivasiRole || isHqRole) && String(currentStatusFlag ?? "").trim() === "";
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem("blockIds") || "[]");
    return Array.isArray(ids) && ids.map(Number).includes(8);
  })();
  const statusUnitCode = localStorage.getItem("statusUnitCode");
  const [blockCDFData, setBlockCDFData] = useState({
    blockCList: [],
    blockDList: [],
    blockFList: [],
    diffValueFormD: 0,
    diffValue: 0,
  });
  const [blockFItem11Value, setBlockFItem11Value] = useState(0); // Store Block F Item 11 value

  useEffect(() => {
    const blockDData = async () => {
      const newObject = {
        dsl_no: blockInfo.dslNo,
        survey_year: blockInfo.surveyYear,
      };
      showAppLoading(true)
      try {
        // Get R&D unit status from localStorage (set by BlockB)
        const rdUnitStatus = localStorage.getItem('rdUnitStatus');

        const response = await axios.post(
          `${API_URL}api/asi/blockGForm`,
          newObject,
          config
        );
        const res = response.data;
        const status = res.status;
        // API may return { status, message, data: { blockGData, diffValueFormD, ... } } or flat structure
        const data = res.data || res;
        const apiData = data || res;
        
        if (status) {
          const responseBlockGData = (apiData.blockGData || data?.blockGData || []);
          setBlockGData(responseBlockGData);
          // Map diffValueFormD from response (camelCase or snake_case); Item 7 always uses this value
          const rawDiffValueFormD = apiData.diffValueFormD ?? apiData.diff_value_form_d ?? data?.diffValueFormD ?? data?.diff_value_form_d;
          const numDiffValueFormD = rawDiffValueFormD != null && rawDiffValueFormD !== ''
            ? Number(parseFloat(rawDiffValueFormD))
            : 0;
          const rawDiffValue = apiData.diffValue ?? apiData.diff_value ?? data?.diffValue ?? data?.diff_value;
          const numDiffValue = rawDiffValue != null && rawDiffValue !== ''
            ? Number(parseFloat(rawDiffValue))
            : 0;
          setBlockCDFData({
            blockCList: apiData.blockCList ?? data?.blockCList ?? [],
            blockDList: apiData.blockDList ?? data?.blockDList ?? [],
            blockFList: apiData.blockFList ?? data?.blockFList ?? [],
            diffValueFormD: isNaN(numDiffValueFormD) ? 0 : numDiffValueFormD,
            diffValue: isNaN(numDiffValue) ? 0 : numDiffValue,
          });
          
          // Fetch Block F Item 11 value
          // Try to get from blockFList[1] first (if API returns it at that index)
          let item11Value = 0;
          if (data.blockFList && data.blockFList.length > 1) {
            item11Value = parseFloat(apiData.blockFList[1]) || 0;
          }
          
          // If blockFList[1] doesn't have the value, fetch from Block F API
          if (item11Value === 0 || isNaN(item11Value)) {
            try {
              const blockFResponse = await axios.post(
                `${API_URL}api/asi/blockFForm`,
                {
                  dsl_no: blockInfo.dslNo,
                  survey_year: blockInfo.surveyYear,
                },
                config
              );
              if (blockFResponse.data.status && blockFResponse.data.data.blockFData) {
                const blockFData = blockFResponse.data.data.blockFData;
                // Find Item 11: Serial number 11 = Index 12 (based on Block F serial logic)
                // Index 0=Serial 1, Index 1=Serial 2, Index 2-3=No serial, Index 4+=Serial (i-1)
                // So Serial 11 = Index 12
                if (blockFData.length > 12) {
                  const item11Data = blockFData[12];
                  if (item11Data && item11Data.expenditure) {
                    item11Value = parseFloat(item11Data.expenditure) || 0;
                  }
                }
              }
            } catch (error) {
              console.error("Error fetching Block F Item 11:", error);
            }
          }
          
          setBlockFItem11Value(item11Value);
          
          const statusFlage = responseBlockGData[0].statusFlag;
          const IsButtonStatus = await validateButtonASIBlock(
            decode_token,
            statusFlage
          );
          const initialData = {};
          
          // Item 7 = "Variation in stock of semi-finished goods" (itemCode 87) – always map from diffValueFormD
          const item7ItemCode = responseBlockGData.length > 6 ? responseBlockGData[6].itemCode : null;
          const diffValueFormDFromApi = apiData.diffValueFormD ?? apiData.diff_value_form_d ?? data?.diffValueFormD ?? data?.diff_value_form_d;
          const hasValidDiffFromApi = diffValueFormDFromApi != null && diffValueFormDFromApi !== '' && !isNaN(parseFloat(diffValueFormDFromApi));
          const item7DisplayValue = hasValidDiffFromApi ? String(parseFloat(diffValueFormDFromApi)) : (responseBlockGData[6]?.recipts ?? '');
          
          responseBlockGData.forEach((item) => {
            let receiptsValue = item.recipts;
            if (item.itemCode === item7ItemCode) {
              // When API sends diffValueFormD (e.g. 10), always use it for Item 7; only when missing/zero apply R&D rule
              if (hasValidDiffFromApi) {
                receiptsValue = item7DisplayValue;
              } else if (rdUnitStatus === '3') {
                receiptsValue = '0';
              } else {
                receiptsValue = item7DisplayValue || '';
              }
            }
            
            initialData[item.itemCode] = {
              dslNo: item.dslNo,
              surveyYear: item.surveyYear,
              itemCode: item.itemCode,
              recipts: receiptsValue,
              statusFlag: item.statusFlag,
              ItemsName: item.ItemsName,
              reciptsClass: "textBox_back_color_white",
            };
          });

          setItemData(initialData);
          setButtonStatus(IsButtonStatus);
        }
      } catch (error) {
        console.error(error);
        toast.error(
          "An error occurred while processing your request.",
          messages.COLOR_RED
        );
      } finally {
        showAppLoading(false);
      }
    };
    blockDData();
  }, []);

  // Function to handle State on change
  const handleOnChange = (catagoryId, field, newValue) => {
    // Allow negative values: check if it's a valid number (including negative)
    const isValid = newValue === "" || /^-?\d*(\.\d*)?$/.test(newValue);
    
    if (!isValid) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = "";
    }

      setItemData((prevItemData) => {
        const updatedItemData = {
          ...prevItemData,
          [catagoryId]: {
            ...prevItemData[catagoryId],
            [field]: newValue,
          },
        };

      return updatedItemData;
    });
  };

  // Function to handle reset Form Data
  const handleReset = () => {
    const initialData = {};
    blockGData.forEach((item) => {
      initialData[item.itemCode] = {
        recipts: "",
        reciptsClass: "textBox_back_color_white",
      };
    });
    setItemData(initialData);
  };



  // Function to handle going to the previous block
  const handlePrevious = () => {
    const confirmed = window.confirm("Have you saved your changes?");
    if (confirmed) {
       navigate("/BlockF");
    }
  };
  

  // Function to handle going to the next block
  const handleNext = async () => {
      // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
      if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
        navigate("/BlockH");
        return;
      }
      // DIVASI + statusFlag=1: do not save, just navigate
      if (isDivasiStatusFlagOne) {
        navigate("/BlockH");
        return;
      }
      // HQADM/HQASI + statusFlag=3: do not save, just navigate
      if (isHqStatusFlagThree) {
        navigate("/BlockH");
        return;
      }
      const confirmed = window.confirm("Have you saved your changes?");
      if (!confirmed) return;
      if(statusUnitCode==='5'){
        const saveResult = await handleSaveData("SAVE");
        if (saveResult) {
          blockValidation()
          navigate("/BlockH")
       }
  }else{
        const saveResult = await handleSaveData("SAVE");
       if (saveResult) {
           blockValidation()
           navigate("/BlockH");
        }
      }
      
  };


 //All block validation Data
 const  blockValidation=async()=>{

  let  postData= {
     dsl_no: blockInfo.dslNo,
     survey_year: blockInfo.surveyYear
    }

 try {
    showAppLoading(true);
     const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
     const {data,status} = response.data;
     const accessIds=data.allblockData
      if(accessIds.length>0){

        if(accessIds.length > [1,2,3,4,5,6,7,8].length){
          accessAsiBlock(accessIds)
        }else{
          accessAsiBlock([1,2,3,4,5,6,7,8])
        }
        
      }else{
        accessAsiBlock([1,2,3,4,5,6,7,8])
      }
      showAppLoading(false);
       return true;

     } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
    
   }

}





  const handleSaveData = async (buttonType) => {
    if (statusUnitCode !== '5' && !valForBlockG()) {
      return false;
    }
    const clickButtonStatusFlag = getStatusFlagValue(
      buttonType,
      userInfoObject.userLevel
    );

    const customItemCodes = Object.values(itemData).map((item) => ({
      dslNo: item.dslNo,
      surveyYear: item.surveyYear,
      itemCode: item.itemCode,
      recipts: handleValue(item.recipts),
      statusFlag: clickButtonStatusFlag,
    }));

    const newObject = {
      itemCodes: customItemCodes,
      payload: {
        dsl_no: blockInfo.dslNo,
        survey_year: blockInfo.surveyYear,
        buttonType: buttonType,
      },
    };
    console.log("blockg newObject--------------",newObject)

    showAppLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}api/asi/blockGFormSaveToDB`,
        newObject,
        config
      );
      const { status, message } = response.data;
      if (status) {
        // accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8]);
        blockValidation()
        toast.success(message, messages.COLOR_RED);
        return true;
      }
    } catch (error) {
      console.error(error);
      toast.error(
        "An error occurred while processing your request.",
        messages.COLOR_RED
      );
    } finally {
      showAppLoading(false);
    }

    return false;
  };

  const valForBlockG = () => {
    let blockCdata = blockCDFData.blockCList;
    let blockDdata = blockCDFData.blockDList;
    let blockFdata = blockCDFData.blockFList;
    let diffValueFormDData = blockCDFData.diffValueFormD;
    let diffValueData = blockCDFData.diffValue;
    let flagG = 0;
    let allValidactionAlertBlockG = "";
    let allSoftValidactionAlertBlockG = "";
    let statusAlertG = 0;
    let yearArray = [2017, 2018, 2019, 2020, 2021];
    let allObjectData = itemData;

    if (
      yearArray.includes(blockInfo.surveyYear) &&
      !(
        statusUnitCode === "4" ||
        statusUnitCode === "5" ||
        statusUnitCode === "7" ||
        statusUnitCode === "8"
      )
    ) {
      const blockGval6 = parseFloat(handleValue(allObjectData[86]?.recipts));
      //#Validation with Block C
      //# 1
      if (blockGval6 > 0) {
        if (
          blockCdata.indexOf(59) > 0 ||
          blockCdata.indexOf(60) > 0 ||
          blockCdata.indexOf(61) > 0 ||
          blockCdata.indexOf(62) > 0 ||
          blockCdata.indexOf(63) > 0
        ) {
          allObjectData[86].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[86].reciptsClass = "textBox_back_color_red"; //'#FF0000';
          allValidactionAlertBlockG =
            allValidactionAlertBlockG +
            " If item 6 of Blk. G > 0, there should be entry in one of  items 3 to 7 in Blk. C. \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      //# 2
      const blockGval8 = parseFloat(handleValue(allObjectData[88]?.recipts));
      if (blockGval8 > 0) {
        if (blockCdata.indexOf(58) > 0) {
          allObjectData[88].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[88].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG +
            " If item 8 of Blk. G > 0, there should be entry in item 2 in Blk. C. \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      //#Validation with Block D
      //# 3
      const blockGval10 = parseFloat(handleValue(allObjectData[90]?.recipts));
      if (blockGval10 > 0) {
        if (
          blockDdata.indexOf(28) > 0 ||
          blockDdata.indexOf(29) > 0 ||
          blockDdata.indexOf(30) > 0
        ) {
          allObjectData[90].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[90].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG +
            " If item 10 of Blk. G > 0, there should be entry in any one of  the items 8 to 10 in Blk. D. \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      //#Validation with Block F
      //# 4

      const blockGval4 = parseFloat(handleValue(allObjectData[84]?.recipts));
      if (blockGval4 > 0) {
        if (parseFloat(blockFdata[0]) > 0) {
          allObjectData[84].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[84].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG + " If G4 > 0 Then F4 Also > 0 \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      if (parseFloat(blockFdata[0]) > 0) {
        if (parseFloat(blockGval4) > 0) {
          allObjectData[84].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[84].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG + "  If F4 > 0 Then G4 Also > 0 \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      //# 5

      const blockGval11 = parseFloat(handleValue(allObjectData[91]?.recipts));
      if (blockFdata[1] > 0) {
        if (blockGval11 > 0) {
          allObjectData[91].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[91].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG + "  If G11 > 0 Then F11 Allso > 0  \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      if (blockGval11 > 0) {
        if (parseFloat(blockFdata[1]) > 0) {
          allObjectData[91].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[91].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG + "  If F11 > 0 Then G11 Allso > 0  \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      if (parseFloat(blockFdata[0]) > 0 && blockGval4 > 0) {
        if (parseFloat(blockFdata[0]) <= blockGval4) {
          allObjectData[91].reciptsClass = "textBox_back_color_white";
        } else {
          allObjectData[91].reciptsClass = "textBox_back_color_orange";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG +
            "  G4 will be greater than or equal to F4.  \n";
          flagG = 1;
          statusAlertG = 1;
        }
      }

      //(Item 11 of Blk. F) *0.90<=  item 11 of Blk. G.
      if (parseFloat(blockFdata[1]) * 0.9 <= blockGval11) {
        allObjectData[91].reciptsClass = "textBox_back_color_white";
      } else {
        // alert("High variations in purchase & sale of trading goods' :Block F, item 11 and Block G, item 11.")
        allObjectData[91].reciptsClass = "textBox_back_color_orange";
        allSoftValidactionAlertBlockG =
          allSoftValidactionAlertBlockG +
          " (Item 11 of Blk. F) *0.90<=  item 11 of Blk. G.  \n";
        statusAlertG = 1;
      }
    }
    const blockGval7 = parseFloat(handleValue(allObjectData[87]?.recipts));


    if (parseFloat(diffValueFormDData) !== blockGval7) {
      allObjectData[87].reciptsClass = "textBox_back_color_red";
      flagG = 1;
    } else {
      allObjectData[87].reciptsClass = "textBox_back_color_white";
      //flagG=0;
    }

    // Validation: Item 5 (itemCode 85) = Item 11 of Block G (itemCode 91) - Item 11 of Block F
    // Formula: Item 5 = BlockG Item 11 - BlockF Item 11
    if (allObjectData[85] && allObjectData[91]) {
      const item5Value = parseFloat(handleValue(allObjectData[85]?.recipts)) || 0;
      const item11BlockG = parseFloat(handleValue(allObjectData[91]?.recipts)) || 0;
      
      // Get Block F Item 11 value from state (fetched during component mount)
      const item11BlockF = blockFItem11Value || 0;
      
      console.log("item11BlockG", item11BlockG);
      console.log("item11BlockF", item11BlockF);
      console.log("blockFItem11Value from state", blockFItem11Value);
      
      const expectedItem5Value = item11BlockG - item11BlockF;
      const safeExpectedItem5Value = isNaN(expectedItem5Value) ? 0 : expectedItem5Value;
      
      // Always validate if Item 11 of Block G or Item 11 of Block F has a value (including negative values)
      if (item11BlockG !== 0 || item11BlockF !== 0 || item5Value !== 0) {
        const tolerance = 0.01;
        const safeItem5Value = isNaN(item5Value) ? 0 : item5Value;
        
        if (Math.abs(safeItem5Value - safeExpectedItem5Value) > tolerance) {
          allObjectData[85].reciptsClass = "textBox_back_color_red";
          allValidactionAlertBlockG =
            allValidactionAlertBlockG +
            " Item 5 of Block G should be equal to (Item 11 of Block G - Item 11 of Block F). Expected: " + safeExpectedItem5Value.toFixed(2) + ", Got: " + safeItem5Value.toFixed(2) + " \n";
          flagG = 1;
          statusAlertG = 1;
        } else {
          allObjectData[85].reciptsClass = "textBox_back_color_white";
        }
      } else {
        allObjectData[85].reciptsClass = "textBox_back_color_white";
      }
    }
    handleValidationAlert(allObjectData);
    if (statusAlertG === 1 && allSoftValidactionAlertBlockG !== "") {
      allSoftValidactionAlertBlockG =
        allSoftValidactionAlertBlockG + " \nFor change any Values Click OK.";
      var clicked = window.confirm(allSoftValidactionAlertBlockG);
      allSoftValidactionAlertBlockG = "";
      statusAlertG = 0;
      if (clicked) {
        // valifla = "notnull";
        return false;
      }
    }
    if (flagG === 1) {
      statusAlertG = 0;
      alert(
        allValidactionAlertBlockG +
          "\n Total does not match. Please check highlighted fields"
      );
      flagG = 0;
      return false;
    }
    return true;
  };

  const handleValidationAlert = (allObjectData) => {
    const initialData = {};
    for (let itemCode in allObjectData) {
      const item = allObjectData[itemCode];
      initialData[itemCode] = {
        dslNo: item.dslNo,
        surveyYear: item.surveyYear,
        itemCode: item.itemCode,
        recipts: item.recipts,
        statusFlag: item.statusFlag,
        ItemsName: item.ItemsName,
        reciptsClass: item.reciptsClass,
      };
    }
    setItemData(initialData);
  };

  const handleValue = (value) => {
    return value !== "" && value !== null && value !== undefined ? value : 0;
  };

  const storedLanguage = localStorage.getItem('language');
  

  return (
    <div className="card-body">
      {/* <ToastContainer /> */}
      <h4 className="page_heading border-bottom-0">
      <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_G_TITLE : asiTitle.en.BLOCK_G_TITLE }} />
      </h4>
      <div className="row">
        <div className="col-12">
          <h6 className="fw-semibold">
          {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span> 
          {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
          </h6>
          <div className="table-responsive asi_block_table">
            <table
              cellPadding="0"
              cellSpacing="0"
              id=""
              className="table table-bordered block_c_table"
            >
              <thead>
                <tr>
                <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEMS : asiTitle.en.ITEMS}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.RECEIPTS : asiTitle.en.RECEIPTS}</th>
                </tr>
                <tr>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                </tr>
              </thead>
              <tbody>
                {blockGData.length > 0 &&
                  blockGData.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{++i}</td>
                        <td>
                          {i === 7 ? <b> {item.ItemsName}</b> : item.ItemsName}
                        </td>
                        <td className={itemData[item.itemCode]?.reciptsClass || 'textBox_back_color_white'}>
                          <input
                            type="text"
                            className="form-control"
                            value={itemData[item.itemCode]?.recipts ?? ''}
                            id={`recipts_${item.itemCode}_${i}`}
                            name={`recipts_${item.itemCode}_${i}`}
                            maxLength="15"
                            onChange={(e) =>
                              handleOnChange(
                                item.itemCode,
                                "recipts",
                                e.target.value
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <hr />
        </div>

        <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
          <button
            type="submit"
            className="btn btn_orange me-1"
            onClick={() => {
              window.print();
            }}
          >
            Print
            <i className="fa fa-print ms-1"></i>
          </button>

          <button
            type="button"
            className="btn btn_orange me-1"
            onClick={(e) => {
              handleSaveData("SAVE");
            }}
            disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
          >
            Save
          </button>

          <button
            type="reset"
            className="btn btn_orange me-1"
            onClick={handleReset}
          >
            Reset
          </button>

          <button
            type="button"
            className="btn btn_orange"
            onClick={(e) => navigate("/dashboard")}
          >
            Cancel
          </button>
        </div>

        <div className="col-lg-4 text-center text-lg-end">
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handlePrevious}
          >
            <i className="fa fa-angle-left me-1"></i>
            Previous
          </button>

          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handleNext}
            disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
          >
            Next
            <i className="fa fa-angle-right ms-1"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default BlockG;
